interface LegacyV2PatientRecordRedirectParams {
  baseHref: string;
  hash: string;
  origin: string;
}

export function resolveLegacyV2PatientRecordRedirectUrl({
  baseHref,
  hash,
  origin,
}: LegacyV2PatientRecordRedirectParams): string | null {
  const match = String(hash || '').match(/^#\/patient\/([1-9]\d*)\/?(?:\?([^#]*))?$/);

  if (!match) {
    return null;
  }

  const [, patientId, queryString] = match;
  const querySuffix = queryString ? `?${queryString}` : '';

  return `${origin}${normalizeBaseHref(baseHref)}patient/${patientId}${querySuffix}`;
}

function normalizeBaseHref(baseHref: string): string {
  const normalizedBaseHref = String(baseHref || '/').trim();

  if (!normalizedBaseHref || normalizedBaseHref === '/') {
    return '/';
  }

  return `/${normalizedBaseHref.replace(/^\/+|\/+$/g, '')}/`;
}
